import { ApiClientService, RequestConfig } from '@dfl/react-security';
import { IPromotionCampaign } from 'modules/campaigns/interfaces';
import { EntityApiService } from 'modules/common/service';
import { CAMPAIGN_STATUS_ENUM } from 'modules/campaigns/constants/common/status.enum';
import { ICurrency } from 'modules/common/constants';

class PromotionCampaignService extends EntityApiService<IPromotionCampaign | Error> {
  evaluate = (id: string, currency: ICurrency, config?: RequestConfig): Promise<IPromotionCampaign> => {
    return this.handleResponse(ApiClientService.post(this.getPath(`/${id}/${currency}/evaluate`), {}, config));
  };

  updateStatus = (id: string, status: CAMPAIGN_STATUS_ENUM, config?: RequestConfig) => {
    return this.handleResponse(ApiClientService.post(this.getPath(`/${id}/${status}`), {}, config));
  };
}

export default new PromotionCampaignService('/ms-business/api/promotion-campaign');
